module.exports = __webpack_public_path__ + "617595d0897443ef0717b5fdde5d2b3e.png";